module.exports = __webpack_public_path__ + "static/hero-guarantee-mobile-2c538342feeb997dc762f1f82dfab184.jpg";